import { useTranslation } from "@/components/Joyspace/context";
import React, { useCallback, useEffect, useState, useContext } from "react";
import { Folder, Page } from "../types";
import "../index.less";
import DataList from "../DataList";
// import { request as joyspaceRequest } from '@/components/Joyspace/api';
import { request as joyspaceRequest } from "@/components/Joyspace/api/request";
import { PAGE_SIZE, transformOriginToPage } from "../utils";
import GlobalContext from "@/context/GlobalContext";
export default function TabPanelSearch() {
  const t = useTranslation();
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [listItems, setListItems] = useState<Array<Page | Folder>>([]);
  const {
    appRuntimeEnv: { joyspaceApiHost }
  } = useContext(GlobalContext);
  const loadFunc = useCallback(
    (params: Record<string, string | number>) => {
      // setLoading(true);
      return joyspaceRequest({
        api: "joyspace.collection.list",
        path: `v1/collections`,
        params: { target_type: 1, start: params.start || 0, length: params.length }
      }).then((info) => {
        const rs = { total: 0, pages: [] };
        if (info?.data) {
          rs.total = info.total || 0;
          rs.pages = (info.data || []).map((page: any) =>
            transformOriginToPage(page.info, joyspaceApiHost)
          );
        }
        return rs;
      });
    },
    [joyspaceApiHost]
  );

  const loadMoreFunc = useCallback(() => {
    loadFunc({
      start: listItems.filter((item) => item.type === "page").length,
      length: PAGE_SIZE
    }).then((info) => {
      const pages: Page[] = info.pages || [];
      const newItems = listItems.slice();
      for (const page of pages) {
        const index = listItems.findIndex((item) => item.type === page.type && item.id === page.id);
        if (index < 0) {
          newItems.push(page);
        }
      }
      setListItems(newItems);
      // setLoading(false);
      setHasMore(info.pages.length === PAGE_SIZE);
    });
  }, [listItems, loadFunc]);

  useEffect(() => {
    loadFunc({ length: PAGE_SIZE }).then((info) => {
      if (info) {
        setListItems(info.pages || []);
        setLoading(false);
        setHasMore(info.pages.length === PAGE_SIZE);
      }
    });
  }, [loadFunc]);

  return (
    <DataList
      items={listItems}
      onBack={() => {
        setLoading(true);
        setHasMore(false);
        setListItems([]);
      }}
      hasMore={hasMore}
      loading={loading}
      loadMore={loadMoreFunc}
    />
  );
}
